// Import the necessary Firebase SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // For Firestore
import { getDatabase } from "firebase/database"; // For Realtime Database
import { getAuth } from "firebase/auth"; // For Authentication
import { getStorage } from "firebase/storage"; // For Storage
// import { getAnalytics } from "firebase/analytics"; // For Analytics (Optional)

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDPZjxPoWbLaR37Uvujcv3U1Jtpz3Ss-mQ",
  authDomain: "maideaze-app.firebaseapp.com",
  databaseURL: "https://maideaze-app-default-rtdb.firebaseio.com",
  projectId: "maideaze-app",
  storageBucket: "maideaze-app.firebasestorage.app",
  messagingSenderId: "554920869225",
  appId: "1:554920869225:web:466dc40942c53badf011f8",
  measurementId: "G-363C73WJRL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);
export { app, firestore, database, auth, storage };